import { render } from "./FormInput.vue?vue&type=template&id=650334c7&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=650334c7&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650334c7"]])

export default __exports__